<template>
	<div>
		<layout>
			<div slot="masthead">
				<masthead>
					<template slot="masthead-image"><img src="~img/about/employees/jay-king-masthead.jpg"></template>
					<template slot="headline">Jay King</template>
					<template slot="sub-headline">Co-founder and COO</template>
				</masthead>
			</div>
			<div class="content" slot="body">
				<div class="content__block">
					<p>Donec sed odio dui. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec ullamcorper nulla non metus auctor fringilla. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Aenean lacinia bibendum nulla sed consectetur. Maecenas faucibus mollis interdum.</p>
					<p>Donec ullamcorper nulla non metus auctor fringilla. Maecenas faucibus mollis interdum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nulla vitae elit libero, a pharetra augue.</p>
					<p>Lum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nullam id dolor id nibh ultricies vehicula ut id elit. Nulla vitae elit libero, a pharetra augue. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod.</p>
				</div>

			</div>
			<template slot="footer">
				<FooterCTA />
			</template>
		</layout>
	</div>
</template>

<script>
	import Layout from '@/layouts/layoutB'
	import Masthead from '@/layouts/layoutB/masthead'
	import FooterCTA from '@/components/FooterCTA'

	export default {
		components: { Layout, Masthead, FooterCTA },
		routeConfig: {
			path: ':slug'
		}
	}
</script>

<style lang="scss" scoped>
	.content {
		width:100%; padding:8.7rem 0 0; color:#6D6E71;
		/deep/{
			a {
				color:#FDB913; text-decoration:none;
				&:hover {
					text-decoration:underline;
				}
			}
			& img {
				padding:7.7rem 0; width:100%;
			}
			& p {
				&:first-child {
					margin-top:0;
				}
				&:last-child {
					margin-bottom:0;
				}
			}
			& strong {
				color:#3D3D3D; font-weight:600;
			}
		}
		&__intro, &__block {
			padding:0 11.2rem;
		}
		&__blockqoute {
			font-size:4rem; line-height:1.25; font-weight:400; font-family:'oswald'; color:#FDB913; position:relative; text-transform:uppercase; margin-left:1.6rem;
			&:before {
				content:'“'; position:absolute; left:-.8rem; top:0; transform:translateX(-50%); font-size:inherit;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/routes/our-company/entry.vue